type Pagination = {
  results: string;
  perPage: string;
  prevPage: string;
  nextPage: string;
  pages: Page[];
};
type Page = {
  page: string;
  url: string;
  active: boolean;
};
const pagination = {
  pagination: (window as any).pagination as Pagination,
  wrap: document.getElementById("paginationWrap") as HTMLElement | undefined,
  init() {
    this.createPagination();
  },
  createPagination() {
    if (this.wrap && this.pagination) {
      const pages = Math.ceil(
        +this.pagination.results / +this.pagination.perPage
      );
      this.wrap.appendChild(this.createLinks(this.pagination.prevPage, false));
      const div = document.createElement("div");     
      div.appendChild(this.createSpan("Page:"));
      div.appendChild(
        this.pagination.pages ? this.createSelect() : this.createSpan("1")
      );
      div.appendChild(this.createSpan("of " + pages));
      this.wrap.appendChild(div);
      this.wrap.appendChild(this.createLinks(this.pagination.nextPage, true));
    }
  },
  createSpan(text: string) {
    const span = document.createElement("span");
    span.innerText = text;
    return span;
  },
  createLinks(page: string, next: Boolean) {
    const pageLink = document.createElement("a");
    pageLink.href = page || "";
    pageLink.className = `pagination__link ${
      !page ? "pagination__link--disable" : ""
    }`;
    pageLink.innerHTML = next
      ? 'Next <svg><use xlink:href="#chevron-right-regular"></use></svg>  '
      : '<svg><use xlink:href="#chevron-left-regular"></use></svg> Prev';
    return pageLink;
  },
  createSelect() {
    const select = document.createElement("select");
    const currentUrl = window.location.origin;
    const options = this.pagination.pages
      .map(
        (item) =>
          `<option ${item.active ? "selected" : ""} value=${currentUrl}${
            item.url
          }>${item.page}</option>`
      )
      .join();

    select.innerHTML = options;
    select.addEventListener("change", () => {
      window.location.replace(select.value);
    });

    return select;
  },
};

export default pagination;
